var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconKakaotalk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.345,
    height: 31.553,
    viewBox: "0 0 34.345 31.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#391b1b;}.b{fill:#fae300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-932 -672)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(932 672)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.271,77.391c-9.485,0-17.173,6.078-17.173,13.576,0,4.88,3.258,9.157,8.147,11.55-.359,1.341-1.3,4.858-1.49,5.611-.232.934.343.921.719.67.3-.2,4.706-3.195,6.609-4.489a21.746,21.746,0,0,0,3.188.234c9.484,0,17.173-6.079,17.173-13.576S81.755,77.391,72.271,77.391",
    transform: "translate(-55.098 -77.391)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.386 9.457)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M110.276,185.048h-5.022a.854.854,0,1,0,0,1.708h1.632v6.016a.836.836,0,0,0,.833.833h.182a.835.835,0,0,0,.832-.833v-6.016h1.542a.854.854,0,1,0,0-1.708Z",
    transform: "translate(-104.4 -184.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M263.221,190.765h-2.335v-6.144a.926.926,0,1,0-1.853,0v6.623a.9.9,0,0,0,.014.148.792.792,0,0,0-.014.148.775.775,0,0,0,.775.776h3.413a.775.775,0,0,0,0-1.551Z",
    transform: "translate(-245.276 -183.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M326.819,191.047l-2.6-3.418,2.351-2.352a.816.816,0,1,0-1.154-1.153l-2.911,2.911v-2.413a.927.927,0,1,0-1.853,0v6.826a.927.927,0,1,0,1.853,0v-2.106l.529-.529,2.462,3.23a.829.829,0,1,0,1.325-1Z",
    transform: "translate(-301.412 -183.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M174.88,191.269l-2.5-6.846-.008-.008a1.23,1.23,0,0,0-1.173-.721,1.194,1.194,0,0,0-1.217.862,1.138,1.138,0,0,0-.048.113l-2.461,6.6a.83.83,0,1,0,1.566.55l.426-1.216h3.425l.426,1.216a.83.83,0,1,0,1.566-.55Zm-4.874-2.217,1.151-3.284c.013,0,.024,0,.037,0l1.15,3.281Z",
    transform: "translate(-161.817 -183.694)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKakaotalk);
export default __webpack_public_path__ + "static/media/icon_kakaotalk.d2999b4e897bdf902aabec84302040cb.svg";
export { ForwardRef as ReactComponent };